import { render } from "./CustomModelView.vue?vue&type=template&id=5b1ebbf9&scoped=true"
import script from "./CustomModelView.vue?vue&type=script&lang=js"
export * from "./CustomModelView.vue?vue&type=script&lang=js"

import "./CustomModelView.vue?vue&type=style&index=0&id=5b1ebbf9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1ebbf9"]])

export default __exports__